import type { ReactNode } from 'react';
import styles from './Spinner.module.css';

/**
 * **`Spinner`**（§5.1）。
 *
 * ## 単独で使えない形にしてある
 *
 * §5.1 は「**単独使用を禁じる。必ず工程名か Button の `pending` に内包する**」
 * と定め、「**無名の『処理中…』を禁じた原則 02 は規約として守り、
 * 部品としては持つ**」と書いている。
 *
 * **規約を文書に書くだけでは守られない**ので、**`label` を必須にして
 * 型で執行する** — 名前の無いスピナーを作れない。
 *
 * **`aria-live` は持たせない** — 工程名が変わるたびに読み上げると
 * **不可視フェーズの 78〜102 秒（M15 実測）の間ずっと喋り続ける**。
 * 状態の告知は呼び出し側が 1 か所で行う。
 */
export interface SpinnerProps {
  /** **必須**。**工程名を書く**（「解き方を検討しています」等。§5.5 の文言規約） */
  readonly label: string;
}

export function Spinner({ label }: SpinnerProps): ReactNode {
  return (
    <span className={styles['row']}>
      <span className={styles['spinner']} aria-hidden="true" />
      {label}
    </span>
  );
}
